// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".join-page{position:relative;width:100%;background-color:#20232a;padding-top:30px;padding-bottom:100px}@media(max-width: 991px){.join-page{padding-bottom:45px}}@media(max-width: 768px){.join-page{padding-left:30px;padding-bottom:70px}}@media(max-width: 576px){.join-page{padding-left:0;padding-bottom:110px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
